export default __webpack_public_path__ + "static/media/globalCodeMassUpload.f81a59f1.png";